// extracted by mini-css-extract-plugin
export default {"parent":"Fallback-module__parent__Oz40C","children":"Fallback-module__children__Js1KX","close":"Fallback-module__close__j36z0"};